<template>
    <div class="max pcenter color-light bg-pos-2 bg-size-cover auto-scroll" :style="`backgroundImage: url(${bg.bgImg})`">

        <!--header-->
        <sec-header-widget v-bind="header_data" />

        <!--人口数据包的适用场景-->
        <section id="sec1" class="pad-h-2 mrg-v-2">
            <div class="rel container pad-h-1 pad-v-4 ">

                <!--遮罩-->
                <matteWidget v-bind="bg" />

                <h3 class="rel mrg-b-3 mrg-b-1-s">
                    <span class="fsize-1d5 fsize-d8-s">本数据包解决的问题</span>
                </h3>
                <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s pad-h-1-s" md>
                    <list-widget :text-list="introduce" />
                </article>
            </div>
        </section>

        <!--使用人口数据包的客户-->
        <section>
            <sec-customer-widget />
        </section>

        <!--数据包亮点-->
        <section id="sec2" class="container rel pad-v-4 pad-h-2 mrg-v-2 mrg-v-0-s pad-h-1-s">

            <!--遮罩-->
            <matteWidget v-bind="bg" />

            <h2 class="rel mrg-b-3 mrg-b-1-s"><span class="fsize-1d5 fsize-1-s">数据包亮点</span></h2>
            <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s" md>
                <table-widget v-bind="data_character" />
            </article>
        </section>

        <!--数据内容-->
        <section id="sec3" class="container rel pad-v-4 pad-h-1 mrg-v-2 mrg-v-0-s">

            <!--遮罩-->
            <matteWidget />

            <h3 class="rel mrg-b-3 mrg-b-1-s">
                <span class="fsize-1d5 fsize-1-s">数据内容</span>
            </h3>
            <div class="rel container fsize-1d2 pad-t-2 pjustify" md>
                <tab-widget v-model="data_cont.val" :tags-data="data_cont.tagsData">
                    <article v-for="(tag,i) of data_cont.tagsData.tagList" :key="i" :slot="tag.id"
                             class="rel bg-color-dgray pad-2 round-sm">
                        <div class="alpha-d6 mrg-b-2 fsize-d9">{{tag.desc}}</div>
                        <ul v-if="tag.text_list" class="grid">
                            <li v-for="(text,i) of tag.text_list" :key="i"
                                class="col-6 line-b thick-1 line-neutral pad-b-d5 mrg-b-d5">
                                <b :class="`mrg-r-1 color-${i%2? 'green': 'yellow'}`">·</b>{{text}}
                            </li>
                        </ul>
                        <slider-widget v-if="tag.slider_data" v-bind="tag.slider_data">
                            <img v-for="page of tag.slider_data.pages" :key="page.id" :slot="page.id"
                                 :src="page.src" />
                        </slider-widget>
                    </article>
                </tab-widget>
            </div>
        </section>

        <!--数据应用领域-->
        <section id="sec4">
            <sec-data-apply-widget :bg-color="bg.bgColor" />
        </section>

        <!--获取数据包-->
        <section id="sec5">
            <sec-data-package-widget :matte-data="bg" />
        </section>

        <!--footer-->
        <sec-footer-widget v-bind="footer_data" />
    </div>
</template>

<script>
    import TableWidget from "@/components/BTXUI/table/table-widget"
    import TabWidget from "@/components/BTXUI/tab/tab-widget"
    import SliderWidget from "@/components/BTXUI/slider/slider-widget"
    import ListWidget from "@/components/list-widget"
    import matteWidget from "@/components/matte-widget"
    import SecHeaderWidget from "@/components/sec-header-widget"
    import SecCustomerWidget from "@/components/sec-customer-widget"
    import SecDataPackageWidget from "@/components/sec-data-package-widget"
    import SecDataApplyWidget from "@/components/sec-data-apply-widget"
    import SecFooterWidget from "@/components/sec-footer-widget"

    const name = "opn";

    export default {
        name,
        components: {
            TableWidget,
            TabWidget,
            SliderWidget,
            ListWidget,
            matteWidget,
            SecHeaderWidget,
            SecCustomerWidget,
            SecDataPackageWidget,
            SecDataApplyWidget,
            SecFooterWidget
        },
        data(){
            const bg = {
                bgImg: require(`@/assets/img/daas_case/${name}_bg.jpg`),
                bgColor: "purple"
            }

            return {

                //背景
                bg,

                //头部信息
                header_data: {
                    packageId: name,
                    mainNavData: {
                        logo: require('@/assets/img/logo/logo.png'),
                        navs: [
                            {
                                text: "首页",
                                link: "/"
                            },
                            {
                                text: "本数据包解决的问题",
                                link: {
                                    chapter_id: "sec1",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据包亮点",
                                link: {
                                    chapter_id: "sec2",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据包内容",
                                link: {
                                    chapter_id: "sec3",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据应用领域",
                                link: {
                                    chapter_id: "sec4",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "获取数据包",
                                link: {
                                    chapter_id: "sec5",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            }
                        ]
                    }
                },

                //概述
                introduce: [
                    "对不容易被关注的地区中小型事件进行收集、分类",
                    "对事件的影响力进行实时量化评估",
                    "量化民众在重要社会问题上的口碑及感受",
                    "基于地理位置的网格级话题评估辅助社区治理",
                    "...分类模型灵活支持自定义话题分析"
                ],

                //数据包特点
                data_character: {
                    thead: [
                        {
                            title: "<b class='color-yellow mrg-r-1'>·</b>事件和口碑分析",
                            grow: 1
                        },
                        {
                            title: "<div class='alpha-d6 fsize-d9'>事件和口碑数据分别从地区事件的发生和民众主观感受两个方向，综合反映区域治理的社会影响。</div>",
                            grow: 2
                        }
                    ],
                    tbody: [
                        ["<b class='color-yellow mrg-r-1'>·</b>事件影响力评估和趋势预测", "<div class='alpha-d6 fsize-d9'>数据包指标基于事件传播特性，不仅能够发现区域的大事件，更能够探测出还未爆发的区域中小事件，并评估影响力。</div>"],
                        ["<b class='color-yellow mrg-r-1'>·</b>重点关注民众对地方治理热点话题的主观感受", "<div class='alpha-d6 fsize-d9'>数据包指标支持多级主题分析、由粗到细反映民众关心的社会问题的态势、影响力、民众情绪。</div>"]
                    ],
                    colors: {
                        thead: "neutral",
                        row: {
                            head: "none",
                            odd: "rgba(134,134,134,.4)",
                            even: "neutral"
                        },
                        line: "none",
                        outline: "none"
                    }
                },

                //数据内容
                data_cont: {
                    val: "intro",
                    tagsData: {
                        tagList: [
                            {
                                id: "intro",
                                text: "民众口碑 + 地区事件",
                                desc: "地理范围：目标城市及下属所有区县 起止时间：2019年至今 更新频率：按月更新",
                                text_list: [
                                    "不稳定与侵权",
                                    "教育",
                                    "产业发展与安全",
                                    "医疗",
                                    "教育和未成年",
                                    "环境",
                                    "医疗和视频安全",
                                    "养老",
                                    "交通",
                                    "产业",
                                    "养老",
                                    "交通",
                                    "生态环境",
                                    "文体服务",
                                    "便民和公共设施",
                                    "便民设施"
                                ]
                            },
                            {
                                id: "form",
                                text: "数据包形式",
                                desc: "可视化系统",
                                slider_data: {
                                    pages: [
                                        {
                                            id: "a",
                                            src: require("@/assets/img/daas_case/f7.png")
                                        }
                                    ],
                                    view: {
                                        height: "auto"
                                    },
                                    showDot: {
                                        bottom: "15px",
                                        color: "#fff",
                                        act_color: "#ffcc00"
                                    },
                                    showFlipBtn: true,
                                    autoPlayDuration: 4000,
                                    loop: true
                                }
                            }
                        ],
                        colors: {
                            normal: {
                                text: "rgba(255,255,255,.4)",
                                bg: "rgba(0,0,0,.5)",
                            },
                            act: {
                                text: "#ffcc00",
                                bg: "dgray",
                            },
                            hover: {
                                text: "mgray",
                                bg: "rgba(0,0,0,.5)",
                            },
                        }
                    }
                },

                //底部信息
                footer_data: {
                    package: {
                        title: "地区事件和民众口碑数据包",
                        packageId: name,
                        packageName: "所有与民情事件和民心口碑相关的问题",
                        matteData: bg
                    }
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/router/opn.vue